import URLSearchParams from './classes/URLSearchParams.js';
import FormData from './classes/FormData.js';
import Blob from './classes/Blob.js';
export default {
    isBrowser: true,
    classes: {
        URLSearchParams: URLSearchParams,
        FormData: FormData,
        Blob: Blob
    },
    protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};
